import { useState } from "react";
import { useSelector } from "react-redux";
import TrackingInfo from "./tracking_result/TrackingInfo";
import Asset4 from "../../../assets/images/asset4.png";
import Asset6 from "../../../assets/images/asset5.png";
import RecommendProduct from "./tracking_result/RecommendProduct";
import OrderInfo from "./OrderInfo";
import useGAEventTracker from "../../../hooks/useGAEventTracker";
import { events } from "../../../hooks/config";
import ShipmentInfo from "./tracking_result/ShipmentInfo";
import TrackingPreview from "./TrackingPreview";
import arrow_left from "../../../assets/images/arrow_left.svg";
import { Accordion } from "react-bootstrap";
import ButtonResyncDetail from "../../ButtonResyncDetail";

const TrackingResult = ({ order, assets }) => {
  const { category, action, labels } = events.marketing;
  const GAEventsTracker = useGAEventTracker(category);
  const [stt, setStt] = useState([]);
  const configAssets = { asset4: Asset4, asset5: Asset6 };
  const handleChangeStt = (index) => {
    const arrayClone = [...stt];
    const indexItem = arrayClone.indexOf(index);
    if (arrayClone.includes(index)) {
      arrayClone.splice(indexItem, 1);
    } else {
      arrayClone.push(index);
    }

    setStt(arrayClone);
  };
  const { productRecommend } = useSelector((state) => state.settings);
  const { general: settings } = useSelector((state) => state.settings);
  const { tracking_form } = useSelector((state) => state.i18n);
  const time = Date.now();
  const url = window.location.href.split("?")[0];
  const chooseUrl = window.location.search
    .substring(1)
    .includes("tracking_number");
  function removeParam(key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
      param,
      params_arr = [],
      queryString =
        sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
      params_arr = queryString.split("&");
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
        param = params_arr[i].split("=")[0];
        if (param === key) {
          params_arr.splice(i, 1);
        }
      }
      if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
    }
    return decodeURIComponent(rtn.replace(/\+/g, "%20"));
  }
  const urlBack = removeParam("tracking_number", window.location.href);
  const renderAsset = (index) => {
    const path = assets[index]?.path;
    const baseUrl = assets[index]?.baseUrl;
    return path ? baseUrl + path + `?v=${Date.now()}` : configAssets[index];
  };

  return (
    <div className="omg-special-tracking-result">
      <div className="row">
        <div className="col-xl-8 col-lg-12 omg-special-tracking-result-content">
          <div
            className="omg-special-tracking-breadcrumb"
            aria-label="breadcrumb"
            onClick={() => {
              if (window.dynamicReview)
                localStorage.setItem("preventReload", 1);
            }}
          >
            <div
              className="breadcrumb"
              style={{ gap: "1rem", display: "flex", padding: "1rem 0" }}
            >
              <a href={chooseUrl ? urlBack : () => window.location.reload()}>
                <img src={`${arrow_left}?v=1`} alt="asset" />
              </a>
              <a
                href={urlBack}
                style={{ textDecoration: "none", color: "#101127" }}
              >
                {tracking_form.title}
              </a>
            </div>
          </div>
          {order.map((item, index) => (
            <div className="omg-tracking-result-preview" key={index}>
              <div className="d-flex justify-content-end">
                <ButtonResyncDetail
                  order_id={item?.order_id}
                  trackingCompany={item?.tracking_company}
                  trackingNumber={item?.tracking_number}
                  orderIndex={index}
                />
              </div>
              <Accordion
                alwaysOpen={false}
                defaultActiveKey={order.length > 1 ? -1 : 0}
              >
                <Accordion.Item eventKey={index}>
                  <Accordion.Header>
                    <TrackingPreview order={item} index={index} stt={stt} />
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="card card-body">
                      <TrackingInfo order={item} />
                      <ShipmentInfo order={item} />
                      {settings.show.includes("order_detail") && (
                        <OrderInfo order={item} />
                      )}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          ))}
        </div>

        <div className="col-xl-4 col-lg-12 omg-special-tracking-result-ads">
          <div className="row gx-5">
            <div
              onClick={() => {
                if (assets && assets["asset4"]?.url) {
                  GAEventsTracker(action, labels["asset4"]);
                }
              }}
              className="col-xl-12 col-lg-4 omg-special-tracking-asset-img"
            >
              <a
                href={assets ? assets["asset4"]?.url : ""}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={renderAsset("asset4")}
                  className="img-fluid"
                  alt="..."
                />
              </a>
            </div>
            <div className="col-xl-12 col-lg-4 omg-special-tracking-asset-img recommend-product">
              {productRecommend?.isActive === true && <RecommendProduct />}
            </div>
            <div
              onClick={() => {
                if (assets && assets["asset5"]?.url) {
                  GAEventsTracker(action, labels["asset5"]);
                }
              }}
              className="col-xl-12 col-lg-4 omg-special-tracking-asset-img"
            >
              <a
                href={assets ? assets["asset5"]?.url : ""}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={renderAsset("asset5")}
                  className="img-fluid"
                  alt="..."
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackingResult;
